import React from 'react';
import { Link } from 'react-router-dom';

import bgImg from '../../assets/img/bg/home-11.jpg';

const bgStyle = {
    backgroundImage:`url(${bgImg})`
}

const BannerHomeEleven = () => {

    return (
        <React.Fragment>

            {/* <!-- banner section start --> */}
            <div className="rs-banner style7 modify3 rs-rain-animate" style={bgStyle}>                
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6"> 
                            <div className="banner-content">    
                                <span className="sub-title zIndex1">MODERNA, PROFISSIONAL, ÉTICA.</span>
                                <h2 className="title zIndex1" data-animation="fadeInLeft" data-delay=".3s">Somos uma empresa de TI, mas além disso...</h2>
                                <p className="desc zIndex1" data-animation="fadeInLeft" data-delay=".5s">Combinamos plataformas, ferramentas e metodologias de trabalho ágeis com a nossa experiência no mercado para estar ao lado de sua empresa nos desafios do digital.</p>
                                {/*<ul className="banner-btn zIndex1">
                                    <li><Link to="service/service-details" className="readon started">Vamos iniciar</Link></li>
                                </ul>*/}
                            </div>
                        </div>                            
                    </div>
                </div>
                <div className="line-inner style2 orange-dark">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </div>
            {/* <!-- banner section end --> */}
            
        </React.Fragment>
    );
}

export default BannerHomeEleven;